import { Font, StyleSheet } from '@react-pdf/renderer';
import DINNextLTProRegular from 'fonts/DINNextLTPro-Regular.ttf';
import DINNextLTProBold from 'fonts/DINNextLTPro-Bold.ttf';

Font.register({
	family: 'DINNextLTPro',
	fonts: [{ src: DINNextLTProRegular }, { src: DINNextLTProBold, fontWeight: 700 }],
});

export const styles = StyleSheet.create({
	PDFContainer: {
		paddingHorizontal: 35,
		paddingVertical: 23,
		backgroundColor: '#F7F7F7',
	},
	section: {
		position: 'relative',
		width: '100%',
		minHeight: '100%',
		fontSize: 8,
		fontFamily: 'DINNextLTPro',
	},
	sectionBlock: {
		marginBottom: 30,
	},
	sectionBlockFooter: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		textAlign: 'center',
		minHeight: 50,
		width: '100%',
		paddingVertical: 18,
		paddingHorizontal: 23,
	},
	sectionBlockFooterText: {
		fontSize: 8,
		textTransform: 'uppercase',
		textAlign: 'center',
		color: '#456d86',
	},
	glassConfigImageWlgState: {
		height: 324,
		marginBottom: 35,
	},
	glassConfigImage: {
		display: 'block',
		height: '100%',
		width: '100%',
		objectFit: 'contain',
	},
});
